/*jshint esversion: 11 */
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import Select from 'react-select';

import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { addNewWeeklyActionRecordTemplate } from '../../api/weeklyActionRecordTemplate';
import { getOfferingList } from '../../api/offering';

const CreateWeeklyActionRecordTemplate = ({
  modalOpenState,
  offeringList,
  closeModalHandler,
  onTemplateCreated,
  authUser
}) => {

  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [offeringId, setOfferingId] = useState('');
  const [informationList, setInformationList] = useState([
    { activity: '', type: '' }
  ]);
  const [offeringSearch, setOfferingSearch] = useState('');
  const [showOfferingList, setShowOfferingList] = useState(false);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [offeringOptions, setOfferingOptions] = useState([]);
  const [offeringOptionsLoading, setOfferingOptionsLoading] = useState(false);

  function buildOptions(list) {
    return list.map((item) => ({
      value: item._id,
      label: item.name
    }));
  }




  // Reset form when modal opens
  useEffect(() => {
    if (modalOpenState) {
      fetchOfferingOptions();
      setOfferingId('');
      setInformationList([{ activity: '', type: '' }]);
      setSelectedOffering(null); 
      setRequestError({ show_alert: false, message: '' });
      setSuccessAlert({ show_alert: false, message: '' });
      setOfferingSearch('');
    }
  }, [modalOpenState]);

  // Close dropdown when clicking outside
  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowOfferingList(false);
  //     }
  //   }

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const handleAddInformation = () => {
    setInformationList([...informationList, { activity: '', type: '' }]);
  };

  const handleRemoveInformation = (index) => {
    if (informationList.length <= 1) return;
    const newList = [...informationList];
    newList.splice(index, 1);
    setInformationList(newList);
  };

  const handleInformationChange = (index, field, value) => {
    const newList = [...informationList];
    newList[index][field] = value;
    setInformationList(newList);
  };

  function handleOfferingSelection(selectedItem) {
    setSelectedOffering(selectedItem);
    setOfferingId(selectedItem ? selectedItem.value : '');
  }


  const fetchOfferingOptions = async () => {
    setOfferingOptionsLoading(true);
    const response = await getOfferingList(1, 100);
    if (response) {
      setOfferingOptions(buildOptions(response?.data || []));
      setOfferingOptionsLoading(false);
    }
  };


  // // Filter offerings based on search input
  // const filteredOfferings = offeringList?.filter(offering =>
  //   offering.name.toLowerCase().includes(offeringSearch.toLowerCase())
  // );

  // // Select an offering
  // const selectOffering = (id, name) => {
  //   setOfferingId(id);
  //   setOfferingSearch(name);
  //   setShowOfferingList(false);
  // };

  // Clear offering selection
  // const clearOfferingSelection = () => {
  //   setOfferingId('');
  //   setOfferingSearch('');
  //   setShowOfferingList(true);
  // };

  async function handleTemplateCreation(event) {
    event.preventDefault();
    setRequestError({ show_alert: false, message: '' });

    // Validation
    if (!offeringId) {
      setRequestError({
        show_alert: true,
        message: 'Please select an offering'
      });
      return;
    }

    for (const [index, info] of informationList.entries()) {
      if (!info.activity.trim()) {
        setRequestError({
          show_alert: true,
          message: `Activity #${index + 1} is required`
        });
        return;
      }
      if (!info.type) {
        setRequestError({
          show_alert: true,
          message: `Please select a type for activity #${index + 1}`
        });
        return;
      }
    }

    const data = {
      offering_id: offeringId,
      information: informationList
    };

    setLoading(true);
    const { response, error } = await addNewWeeklyActionRecordTemplate(data);
    setLoading(false);

    if (error) {
      setRequestError({ show_alert: true, message: error });
      return;
    }
    onTemplateCreated();
    setSuccessAlert({ show_alert: true, message: response.message || 'Record created successfully' });
    closeModalHandler();
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert
          success
          title="Created"
          onConfirm={resetSuccessAlert}
        >
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="lg">
        <ModalHeader toggle={closeModalHandler}>
          Create Weekly Action Record Template
        </ModalHeader>
        <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {requestError.show_alert && (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={() => setRequestError({ ...requestError, show_alert: false })}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          )}

          <AvForm className="needs-validation">
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Select Offering</Label>
                  <Select
                    options={offeringOptions}
                    disabled={offeringOptionsLoading}
                    onChange={handleOfferingSelection}
                    value={selectedOffering}
                    placeholder="Select an offering..."
                  />
                </FormGroup>
              </Col>

              <Col md="12" className="d-flex justify-content-between align-items-center my-2">
                <Label>Activities</Label>
                <Button
                  color="primary"
                  size="sm"
                  className="mb-3"
                  onClick={handleAddInformation}
                >
                  <i className="ri-add-line align-middle mr-2"></i>
                  Add Activity
                </Button>
              </Col>
              <Col md="12">
                {informationList.map((info, index) => (
                  <div key={index} className="p-1 mb-1">
                    <Row>
                      <Col md="7">
                        <FormGroup>
                          <Label>Activity {index + 1}</Label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter activity description..."
                            value={info.activity}
                            onChange={(e) =>
                              handleInformationChange(index, 'activity', e.target.value)
                            }
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Type</Label>
                          <select
                            className="form-control"
                            value={info.type}
                            onChange={(e) =>
                              handleInformationChange(index, 'type', e.target.value)
                            }
                            required
                          >
                            <option value="">Select Type</option>
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col md="1" className="d-flex justify-content-center align-items-center">
                        {informationList.length > 1 && (
                          <div className="text-right mt-2">
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleRemoveInformation(index)}
                            >
                              <i className="ri-delete-bin-line align-middle mr-1"></i>
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}
              </Col>
            </Row>

            <ModalFooter>
              <Button
                disabled={loading}
                type="button"
                color="light"
                onClick={closeModalHandler}
              >
                Close
              </Button>
              <Button
                type="button"
                color="success"
                disabled={loading}
                onClick={handleTemplateCreation}
              >
                {loading ? 'Creating...' : 'Create Template'}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(CreateWeeklyActionRecordTemplate);